import { fetcher } from 'webapp-common';

const FETCH_PANELS_URL = '/a/api/panelConfigs';

export const fetchPanels = () => fetcher.get(FETCH_PANELS_URL);
